import { useHomepageSection } from '@/hooks/useHomepageSection';
import { VALUES_COPY } from '@/content/yawasCopy';

interface FeatureItem {
  icon: string;
  title: string;
  description: string;
  color: string;
}

const FeaturesSection = () => {
  const { data } = useHomepageSection('features');

  const title = data?.title?.trim() || VALUES_COPY.title;
  const subtitle = data?.subtitle?.trim() || VALUES_COPY.subtitle;
  const description = data?.description?.trim() || VALUES_COPY.description;

  let features: FeatureItem[] = VALUES_COPY.cards;
  if (data?.extra_json) {
    try {
      const parsed = data.extra_json as FeatureItem[];
      if (Array.isArray(parsed) && parsed.length > 0 && parsed[0]?.title) {
        features = parsed;
      }
    } catch {
      features = VALUES_COPY.cards;
    }
  }

  return (
    <section className="py-20 md:py-28 bg-white">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="text-center mb-14">
          <span className="text-amber-500 text-sm font-semibold tracking-widest uppercase">{subtitle}</span>
          <h2
            className="text-3xl md:text-5xl font-bold text-stone-900 mt-3 mb-4"
            style={{ fontFamily: "'Playfair Display', serif" }}
          >
            {title}
          </h2>
          <p className="text-stone-500 text-base md:text-lg max-w-xl mx-auto">{description}</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {features.map((feature) => (
            <div
              key={feature.title}
              className="bg-stone-50 rounded-2xl p-7 border border-stone-100 hover:border-amber-200 transition-all duration-300 group"
            >
              <div
                className={`w-12 h-12 flex items-center justify-center rounded-xl ${feature.color} mb-5 group-hover:scale-110 transition-transform duration-300`}
              >
                <i className={`${feature.icon} text-xl`}></i>
              </div>
              <h3 className="text-stone-900 font-semibold text-base mb-2">{feature.title}</h3>
              <p className="text-stone-500 text-sm leading-relaxed">{feature.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FeaturesSection;
